





































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import compontentForm from '../../../components/form.vue'
import {
  formAddList
} from '../../../constant/options';
import { getFontFaceList } from "@/utils/getFontFaceList";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    'compontent-form': compontentForm
  },
})
export default class wheelOfFortuneTextStart extends Vue {
  @Prop(Object)
  formData!:object;

  @Prop(Array)
  countryList!:any

  formAddList = formAddList;


  get countdownTimeOption() {
    return [
      { label: this.$t('views.wheeloffortune.setting.text_5206949f') as string, value: 'minute' },
      { label: this.$t('views.wheeloffortune.setting.text_79d2') as string, value: 'second' },
    ];
  }

  formDataStart: any = this.formData

  predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
  ]

  formList = this.formData.settings?.start || []

  fontFaceList = getFontFaceList([
    {
      name: 'Arial',
      value: 'Arial, sans-serif',
      original: true
    },
    {
      name: 'Courier New',
      value: 'Courier New, monospace',
      original: true
    },
    {
      name: 'Georgia',
      value: 'Georgia, serif',
      original: true
    },
    {
      name: 'Times New Roman',
      value: 'Times New Roman, serif',
      original: true
    },
    {
      name: 'Trebuchet MS',
      value: 'Trebuchet MS, sans-serif',
      original: true
    },
    {
      name: 'Verdana',
      value: 'Verdana, sans-serif',
      original: true
    }
  ]);

  countdownTime:string ='minute'

  countDown:number = 5

  collapseArr =  ['1','2']


  compontentFormIsShow = false
  formType = {}

  setformType =  {}

  changcompontentFormIsShow(e:boolean){
    this.compontentFormIsShow= e
  }

  addFormAddList(item:any,index:number){
    if (this.collapseArr.indexOf("1") < 0) {
      this.collapseArr.push('1')
    }
    if(item.type !== '自定义'){
      let a = this.formList.filter((i:any)=>{
        return i.type === item.type
      })

      if(a.length > 0){
        this.formType = a[0]
        this.compontentFormIsShow = true
        return
      }
    }
    
  
    if(this.formList.length < 8){
      this.formType = item
      this.compontentFormIsShow = true
    }else{
      this.$message.error(this.$t('views.wheeloffortune.setting.stylesetting.textstart.max-8-forms') as string)
    }
    window?.gtagClick('form_edit_selectField_'+item?.label.replace(/\s/g, ''),'弹窗_编辑订阅工具_选择采集项_'+item?.label.replace(/\s/g, ''))
  }


  changeFormList(e:any){
    this.formDataStart.settings.start = e 
    this.changeStart()
  }

  changeStart(){
    this.$emit('change',this.formDataStart)
  }

  get formStyle() {
    const timing = this.formDataStart.settings.timing;
    return `
      .cartx-option-columns{
        min-width: ${Math.floor(100 /(timing.optionColumns||1)) -3}%!important;
        color: ${timing.optionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-checkbox__input.is-checked .el-radio__inner {
        border-color: ${timing.optionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-radio__input.is-checked .el-radio__inner {
        border-color: ${timing.optionBackground}!important;
        background: ${timing.optionBackground}!important;
      }
      .cartx-question {
        color: ${timing.optionColor}!important;
      }
    `
  }



  @Watch('formData')
  changeFormData(){
    this.formDataStart =this.formData
  }
  @Watch("formData.settings.rules.countDown")
  changeCountDown(val:number){
    if(val > 60){
      this.countDown = val / 60
      this.countdownTime ='minute'
    }else if(val === 60){
      this.countdownTime = 'second'
      this.$nextTick(() => {
        this.countDown = 60 / 1
      })

    }else {
      this.countDown =val
    }
  }

  @Watch("formData.settings.start")
  changeStartFormList(val:any){
    this.formList = val
  }

}
